/* eslint-disable */
export const ERR_CANCELED = 'ERR_CANCELED'